import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';

import { IS_DEVELOPMENT } from 'shared/config/env';
import { FALLBACK_LNG } from 'shared/constants/translation';

import { useUpdateResources } from './hooks';
import { getTestResources } from './utils';

export const useConfig = () => {
  useUpdateResources();

  if (!i18n.isInitialized) {
    i18n.use(initReactI18next).init({
      fallbackLng: FALLBACK_LNG,
      debug: IS_DEVELOPMENT,
      returnNull: false,
      interpolation: { escapeValue: false },
      detection: { order: ['navigator'] },
      react: {
        transSupportBasicHtmlNodes: true,
      },
      resources: getTestResources(), // add this only for tests
    });
  }

  return { i18n };
};
